import React from 'react'
import * as T from '../../../components/Table'
import { RelatorioItem } from './RelatorioItem'

export const RelatorioLista = ({ data }) => {
  if (!data?.length) {
    return (
      <T.Tr>
        <T.Td colSpan="13" textAlign="center">
          Nenhum registro encontrado
        </T.Td>
      </T.Tr>
    )
  }

  return data.map((item, index) => <RelatorioItem key={index} item={item} />)
}
